export enum BeneficiaryType {
  INDIVIDUAL_BY_NAME = "individual-by-name",
  TRUST = "trust",
}
